export const isProjectNameValid = (projectName: string) => {
  const projName = projectName.trim();
  return projName.match(/^[\w\-\s]+$/) && projName.length > 0;
};
